import { Component } from '@angular/core';
//import * as firebase from 'firebase';

/*const config = {
  apiKey: 'AIzaSyBC5WnoCDppKPzeoh1HNr_SmqGAX5ugrFA',
  databaseURL: 'https://pareekshn-online.firebaseio.com'
};*/

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'ams-angular';
  
  constructor (){
/*    if (!firebase.apps.length) {
      firebase.initializeApp(config);
   }*/

  }
}
